import { contextFactory } from '@frontend/design-system';
import {
  TerminalStepContextProps,
  TerminalStepContextState,
  useTerminalStepSelectedReader,
} from './terminal-step-context';

export type TerminalStepContextJustifiState = TerminalStepContextState;

export const [TerminalStepJustifiContext, useTerminalStepJustifiContext] =
  contextFactory<TerminalStepContextJustifiState>('', {} as TerminalStepContextJustifiState);

export const TerminalStepContextJustifi = ({ children }: TerminalStepContextProps) => {
  const value = useTerminalStepSelectedReader();

  return (
    <>
      <TerminalStepJustifiContext.Provider value={value}>{children}</TerminalStepJustifiContext.Provider>
    </>
  );
};
